module.exports = __webpack_public_path__ + "static/img/aboutUs02.a845f3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutUs/aboutUs02.jpg
// module id = 1354
// module chunks = 1